export var capitalizeFirstLetter = function (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
//# sourceMappingURL=capitalizeFirstLetter.js.map